import React from 'react';
import { SectionHeader } from '../shared/SectionHeader';
import { WACAnalysisTable } from '../tables/WACAnalysisTable';
import classes from '../../bidAnalysisTemplate.module.scss';

interface WACAnalysisSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  formData: any;
  packSizeFormData?: Record<number, any>;
  templateType?: string; // 'mas' | 'nc' - to distinguish between MAS and NC templates
}

export const WACAnalysisSection: React.FC<WACAnalysisSectionProps> = ({
  isExpanded,
  onToggle,
  formData,
  packSizeFormData,
  templateType,
}) => {
  return (
    <div className={classes.section}>
      <SectionHeader
        title="WAC Analysis"
        isExpanded={isExpanded}
        onToggle={onToggle}
      />
      {isExpanded && (
        <div className={classes.sectionContent}>
          <WACAnalysisTable formData={formData} packSizeFormData={packSizeFormData} templateType={templateType} />
        </div>
      )}
    </div>
  );
};

